import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import ChapterHeading from "@/components/ChapterHeading";
import { EJES } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

const ICON_IMGS = {
  1: "/ejes/eje1.webp",
  2: "/ejes/eje2.webp",
  3: "/ejes/eje3.webp",
  4: "/ejes/eje4.webp",
  5: "/ejes/eje5.webp",
};

export default function Ejes() {
  return (
    <section id="ejes" data-testid="ejes-section" className="bg-arena-light py-20 md:py-28 grain relative">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <ChapterHeading
          num="03 · Ejes de Gobierno"
          title="Cinco ejes, resultados medibles"
          desc="El contenido de cada eje y sus subtemas proviene directamente del documento oficial del Segundo Informe de Gobierno."
        />
        <Accordion type="single" collapsible className="space-y-4">
          {EJES.map((eje, i) => {
            return (
              <motion.div
                key={eje.id}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-30px" }}
                transition={{ duration: 0.6, delay: i * 0.06, ease: EASE }}
              >
                <AccordionItem
                  value={`eje-${eje.id}`}
                  className="bg-white rounded-2xl border border-border overflow-hidden shadow-[0_10px_28px_-18px_rgba(90,82,74,0.35)] data-[state=open]:border-guinda/50 transition-colors duration-300"
                >
                  <AccordionTrigger
                    data-testid={`eje-accordion-trigger-${eje.id}`}
                    className="px-6 sm:px-8 py-6 hover:no-underline hover:bg-arena-sand/60 transition-colors duration-200 [&[data-state=open]>div>.eje-num]:text-guinda"
                  >
                    <div className="flex items-center gap-4 sm:gap-6 text-left">
                      <span className="eje-num font-mono text-sm text-gris/60 transition-colors duration-200">
                        0{eje.id}
                      </span>
                      <span className="p-2.5 rounded-xl bg-guinda/10 shrink-0">
                        <img
                          src={ICON_IMGS[eje.id]}
                          alt={`Ícono oficial del Eje ${eje.id}: ${eje.nombre}`}
                          className="w-9 h-9 object-contain"
                        />
                      </span>
                      <span>
                        <span className="block font-mono text-[10px] tracking-[0.3em] uppercase text-guinda">
                          Eje {eje.id}
                        </span>
                        <span className="block font-serif font-semibold text-xl sm:text-2xl text-gris-charcoal mt-1">
                          {eje.nombre}
                        </span>
                      </span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent data-testid={`eje-accordion-content-${eje.id}`} className="px-6 sm:px-8 pb-8">
                    <p className="text-gris text-base leading-relaxed max-w-3xl pt-2">{eje.resumen}</p>
                    <div className="grid sm:grid-cols-2 gap-3 mt-6">
                      {eje.subtemas.map((s, j) => (
                        <div
                          key={j}
                          data-testid={`eje-${eje.id}-subtema-${j}`}
                          className="rounded-xl bg-arena-light/70 border border-border/70 p-5 hover:border-guinda/40 transition-colors duration-200"
                        >
                          <h4 className="font-semibold text-gris-charcoal text-base">{s.titulo}</h4>
                          <p className="mt-1.5 text-sm text-gris leading-relaxed">{s.desc}</p>
                          <p className="mt-3 inline-block text-xs font-medium text-guinda bg-guinda/10 rounded-full px-3 py-1">
                            {s.stat}
                          </p>
                        </div>
                      ))}
                    </div>
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            );
          })}
        </Accordion>
      </div>
    </section>
  );
}
